export default __webpack_public_path__ + "static/media/wallet.80f095b4.svg";